import { createFeatureSelector, createSelector } from '@ngrx/store';
import { STATE_ITEMS, StateItemsState } from './state-items.state';

export const selectStateItemsStore = createFeatureSelector<StateItemsState>(STATE_ITEMS);

export const selectStateByKey = (key: string) => createSelector(selectStateItemsStore, (state) => state.states[key]);
export const selectStateUpdates = (key: string) => createSelector(selectStateByKey(key), (state) => state?.updates ?? []);
